package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * Provenance for an imported directory candidate (present only on seeded listings). Lets admins audit
 * where a listing came from before verifying or publishing it. See `firebase/seed/README.md`.
 */
@Serializable
data class BusinessSource(
    val url: String? = null,
    val directoryUrl: String? = null,
    val retrievedAt: String? = null,
    val verificationStatus: String? = null,
    val reviewRequired: Boolean = true,
)
